<template>
  <section class="container-section">
    <div class="sub-container">
      <section class="section-titles">
        <h3 class="title">
          Gestión portuaria
        </h3>
      </section>
      <section>
        <div class="list-items">
          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="terminalManagement.thcPort"
                class="uk-checkbox"
                type="checkbox"
              > THC Puerto
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="terminalManagement.loadVerification"
                class="uk-checkbox"
                type="checkbox"
              >  Verificación Carga
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="terminalManagement.portSecurity"
                class="uk-checkbox"
                type="checkbox"
              > Seguridad Portuaria
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="terminalManagement.refrigeratedLoadElectricalConnection"
                class="uk-checkbox"
                type="checkbox"
              >
              <span v-if="dollyType === dollyTypeEnum.dryLoad"> Conexión Eléctrica Carga seca </span>
              <span v-if="dollyType === dollyTypeEnum.reefer"> Conexión Eléctrica Carga Refrigerada </span>
              <span class="opt"> (Opcional)</span>
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="terminalManagement.internalMovementCostsYard"
                class="uk-checkbox"
                type="checkbox"
                min="0"
              > Costos Movimientos Internos en Patio
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="terminalManagement.penaltyDifferencesWeighing"
                class="uk-checkbox"
                type="checkbox"
                min="0"
              >  Penalización por Diferencias en Pesaje
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="terminalManagement.portImprovementRate"
                class="uk-checkbox"
                type="checkbox"
              > Tasa de Mejoramiento de Puertos
            </label>
          </div>
        </div>
      </section>
    </div>
    <div class="btn">
      <wizard-button />
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { dollyTypeEnum } from '../../../types'
export default {
  data () {
    return {
      dollyTypeEnum,

      terminalManagement: {
        thcPort: null,
        loadVerification: null,
        portSecurity: null,
        refrigeratedLoadElectricalConnection: null,
        internalMovementCostsYard: null,
        penaltyDifferencesWeighing: null,
        portImprovementRate: null
      }
    }
  },

  computed: {
    ...mapGetters([
      'terminalManagementStore',
      'dollyType'
    ])
  },

  watch: {
    terminalManagement: {
      handler: function (newVal) {
        this.$store.commit('setTerminalManagement', newVal)
      }
    }
  },

  mounted () {
    this.terminalManagement = { ...this.terminalManagementStore }
  }

}
</script>

<style scoped>
.uk-padding{
  padding-top: 5px;
  padding-right: 5px;
}
section{
  padding: 10px;
  width: 100%;
}

.title{
  font-weight: 600;
  margin-bottom: 10px;

}

.sub-container{
  min-height: 418px;;
}
.container-section{
  padding: 10px 40px;
}
.section-titles{
  width: 85%;
  padding: 0px
}
.btn{
  padding-right:25px ;
}

.opt{
  font-size: 12px;
  color: rgb(151, 151, 151);

}
.list-items{
  display: flex;
  flex-wrap: wrap;
}
.items{
  min-width: 310px;
  margin-bottom: 30px
}

@media screen and (max-width: 879px){
  .section-titles{
    width: 100%;
    padding: 0px;
  }
  .main{
    padding-top: 25px ;
  }
  .title{
    font-size: 17px;
  }
  .helper{
    font-size: 11px;
  }
  *{
    font-size: 12px;
    padding: 0px;
  }
    .container-section{
    padding: 10px 20px;
  }
}

@media screen and (max-width: 689px){
  .title{
    font-size: 13px;
  }
  *{
    font-size: 10px;
  }

  .helper{
    font-size: 10px;
  }
  .item{
    min-width: 100px;
    width: 20%;
    margin: 5px 10px;;
  }
.opt{
    font-size: 10px;
  }
}
</style>
